import React from 'react';
import PropTypes from 'prop-types';
import {Card, CardBody, CardHeader} from "reactstrap";
import {AccordionCollapse, AccordionToggle} from "react-bootstrap";
import {getByModuleId, MODULE_DIAGNOSTICS} from "../Modules";
import DiagnosticsComponentsTypeIdSelect from "../Diagnostics/ComponentsTypeIdSelect";
import TreeMenuNew from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";
import Diagnostic from "../Diagnostics/Diagnostic";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const DiagnosticsAccordion = props => {
  const { getApiPrimaryParams } = useTecRmi()

  return (
    <Card className="mb-0">
      <CardHeader className="cursor-pointer d-flex flex-row justify-content-between align-items-center py-0">
        <AccordionToggle className="py-2 my-1 flex-grow-1" eventKey={getByModuleId(MODULE_DIAGNOSTICS, 'uriName')} as={'div'}>{getByModuleId(MODULE_DIAGNOSTICS, 'name')}</AccordionToggle>
        <div style={{width: 170}}>
          <DiagnosticsComponentsTypeIdSelect
            value={props.diagnosticComponent}
            onChange={props.onDiagnosticComponentChange}
          />
        </div>
      </CardHeader>
      <AccordionCollapse eventKey={getByModuleId(MODULE_DIAGNOSTICS, 'uriName')}>
        <CardBody className="p-3">
          <TreeMenuNew
            items={props.diagnostics.map(diagnostic => ({
              key: `itemMp-${diagnostic.ItemMpId}`,
              id: diagnostic.ItemMpId,
              label: diagnostic.ItemMpText,
              component: Diagnostic,
              componentProps: {
                componentTypeId: props.diagnosticComponent,
                itemMp: diagnostic.ItemMpId,
              }
            }))}
          />
        </CardBody>
      </AccordionCollapse>
    </Card>
  );
};

DiagnosticsAccordion.propTypes = {
  diagnosticComponent: PropTypes.number.isRequired,
  onDiagnosticComponentChange: PropTypes.func.isRequired,
  diagnostics: PropTypes.array.isRequired,
};

export default DiagnosticsAccordion;